export default "/images/vendor/flag-icon-css/flags/1x1/my.svg?848fbf91865a8d1912638bb1c2b8fa0a";